<style lang="less" scoped>
.header{
    margin:20px 0 0 0;
    padding-bottom:10px;
    border-bottom:1px solid rgb(220, 232, 241)
}
.header-font{
    font-size:22px;
    color: #777!important;
    font-weight: lighter;
}
.content-title1{
    background: #3a87ad!important;
    padding: .3em .6em .4em; 
    text-align: center; 
    font-size: 13px; 
    line-height: 1.1;
    font-weight: bold;
    color: white
}
.content-title2{
    background:#82af6f!important;
    padding: .3em .6em .4em; 
    text-align: center; 
    font-size: 13px; 
    line-height: 1.1;
    font-weight: bold;
    color: white;
}

.content-margin{
    margin: 9px 0 0 0;
    display: inline-block;
}
.content-total{
    font-size: 16px;
    font-weight: normal;
    font-family: "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif;
    margin-left:15px;
    display: inline-block;
}
.content-total-bottom{
    font-size: 16px;
    font-weight: normal;
    font-family: "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif;
    margin-left:10px 0 10px 0;
}
.content-total-inform{
    font-size: 14px;
    margin-left: 5px;

}
</style>
<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">结算记录</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <div class="wlplat-el-edit"  style=" overflow-y:auto; overflow-x:auto; width:1500px; height:800px;">
                    <!-- <span class="ahis-ms-time-name">时间</span> -->
            
                     <div class="block header" >
                     <el-row>
                        <el-col :span="6">
                            <span class="header-font"> 
                            月度结算记录-{{stationName}}网点
                            </span>
                        </el-col>
                        <el-col :span="6">
                         <!-- <el-date-picker  v-model="proStartDate" type="year" placeholder="选择年" format="yyyy" @on-change="SearchYear">  </el-date-picker> -->
                         <el-date-picker v-model="proEndDate" type="month" placeholder="选择日期" format="yyyy-MM " @on-change="SearchMonth" size="small"> </el-date-picker>
                            <!-- <el-date-picker v-model="dateValue" type="date" placeholder="选择日期" format="yyyy-MM-dd"  @on-change="SearchDate"> </el-date-picker> -->
                                <button type="primary" class="common-bg-button" @click="initList('search')">搜索</button></br>
                        </el-col>
                        <el-col :span="6">
                            <div v-show="isShow" style="float:right">
                                <button type="primary"  align="right" class="common-bg-button" @click="handleDownload('a')" ><i class="el-icon-download"></i>&nbsp;下载</button> 
                                <button type="primary" class="common-bg-button" @click="handleCommand('a')" ><i class="fa fa-cloud-download"></i>&nbsp;导出</button>
                            </div>
                        </el-col>
                     </el-row>
                     </div>
                                <div v-show="isShow" style="margin-top:24px">
                              
                               <!-- <div  align="right" > -->
                               <!-- <Button type="primary"  align="right" class="wlplat-btn btn" @click="handleDownload('a')" ><i class="el-icon-download"></i>&nbsp;下载</Button> -->
                              <!-- <Button type="primary" class="wlplat-btn btn" @click="handleCommand('a')" ><i class="el-icon-printer"></i>&nbsp;打印</Button> -->
                               <!-- </div> -->
                                <el-container>
                                   
                                    <el-container>
                                        <el-aside width="600px" >
                                             <h1 class="content-title1">服务公司</h1>
                                             <span class="content-margin">公司名称:{{listData5.dealName}}</span></br>
                                             <span class="content-margin" >地址：{{listData5.ownerDisc}}</span></br>
                                             <span class="content-margin" >联系人：{{listData5.contactName}}</span></br>
                                             <span class="content-margin" >联系电话：{{listData5.contactPhone}}</span>
                                        </el-aside>
                                         <!-- <el-main width="50px" ></el-main> -->
                                         <el-aside width="100px"></el-aside>
                                         <el-aside width="600px">
                                             <h1 class="content-title2">网点</h1>
                                             <span class="content-margin" >网点名称：{{listData6.stationName}}</span></br>
                                             <span class="content-margin" >地址：{{listData6.stationAddr}}</span></br>
                                             <span class="content-margin" >站点类型：{{listData6.stationTypeName}}</span></br>
                                             <span class="content-margin" >网点状态：{{listData6.stationStatusName}}</span>
                                         </el-aside> 
                                    </el-container>
                                </el-container>
                     <template>
                       <div class = "wlplat-el-popover-btn-div">
                           <el-row>
                               <!-- <el-col >
                               <el-col align="right">
                            <Button type="primary" class="wlplat-btn btn" @click="handleCommand('a')" ><i class="fa fa-cloud-download"></i>&nbsp;导出</Button>
                               </el-col> -->
                        <el-checkbox-group v-model="checkList">
                            <el-checkbox label="02">APP外部</el-checkbox>
                            <el-checkbox label="03">APP内部</el-checkbox>
                            <el-checkbox label="01">卡</el-checkbox>
                            <el-checkbox label="04">平台</el-checkbox>
                             </el-checkbox-group>
                               <!-- </el-col> -->
                           </el-row>
                    </div>
                        </template>
                    <div style="margin-top:10px">
                        <div  class="content-total" style="margin-left:0"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>订单数:<span class="content-total-inform">{{listData1.totalNum}}</span></div>
                        <div  class="content-total"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>充电时长:&nbsp;<span class="content-total-inform">{{listData7}}</span></div>
                        <div  class="content-total"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>充电电量(度):&nbsp;<span class="content-total-inform">{{listData1.chargeVal}}</span></div>
                        <div  class="content-total"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>实收金额(元):&nbsp;<span class="content-total-inform">{{listData1.actFee}}</span></div>
                        <div  class="content-total"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>产生电费(元):&nbsp;<span class="content-total-inform">{{listData1.elecFee}}</span></div>
                        <div  class="content-total"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>实收电费(元):&nbsp;<span class="content-total-inform">{{listData1.actElecFee}}</span></div>
                        <div  class="content-total"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>服务费用(元):&nbsp;<span class="content-total-inform">{{listData1.servFee}}</span></div>
                    </div>
                     <el-table :data="listData" :stripe="true" class="list_tb" border @selection-change="handleSelection">
                        <el-table-column  type="index" align="center" width="55">
                        </el-table-column>
                        <el-table-column prop="orderNo" label="充电订单编号" min-width="200">
                        </el-table-column>
                        <el-table-column prop="stationName" label="充电网点名称" min-width="110">
                        </el-table-column>
                        <el-table-column prop="pileCode" label="充电桩编号" min-width="170">
                        </el-table-column>
                        <el-table-column prop="custPhone" label="订单用户" min-width="170">
                        </el-table-column>
                        <el-table-column prop="sourceName" label="订单类型" min-width="100" align="right">
                        </el-table-column>
                        <el-table-column prop="beginTime"  label="开始时间" min-width="160">
                        </el-table-column>
                        <el-table-column prop="endTime"  label="结束时间" min-width="160">
                        </el-table-column>
                        <el-table-column prop="chargeMin" label="充电时长" min-width="150">
                        </el-table-column>
                        <el-table-column prop="chargeVal" label="充电电量(度)" min-width="150">
                        </el-table-column>
                        <el-table-column prop="tActFee" label="充电应收费用(元)" min-width="150">
                        </el-table-column>
                         <el-table-column prop="actElecFee" label="充电实收电费(元)" min-width="150">
                        </el-table-column>
                        <el-table-column prop="elecFee"  label="产生电费(元)" min-width="200">
                        </el-table-column>
                        <el-table-column prop="actPayFee" label="实收电费(元)" min-width="150">
                        </el-table-column>
                       
                        <el-table-column prop="servFee"  label="服务费(元)" min-width="200">
                        </el-table-column>                
                     <!--分页区 -->
                    </el-table>
                    <!-- <el-pagination class="page" v-if="listData.length>0" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="pageParams.currentPage" :page-sizes="pageParams.opts" :page-size="pageParams.pageSize" :layout="pageParams.pageLayout"
                        :total="pageParams.total">
                    </el-pagination> -->
                    <div>
                         <el-container>
                                    <!-- <el-header>Header</el-header> -->
                                    <el-container>
                                        <el-aside width="500px"  style="margin-top:10px">  
                                            <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>总订单数:<span class="content-total-inform">{{listData1.totalNum}}</span></div></br>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>APP内部订单数:<span class="content-total-inform">{{listData4.orderNum}}</span></div></br>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>APP外部订单数:<span class="content-total-inform">{{listData3.orderNum}}</span></div></br>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>卡和平台订单数:<span class="content-total-inform">{{listData2.orderNum}}</span></div>
                                        </el-aside>
                                         <el-aside width="500px" style="margin-top:10px">
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>充电时长:<span class="content-total-inform">{{listData7}}</span></div></br>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>充电电量(度):<span class="content-total-inform">{{listData1.chargeVal}}</span></div></br>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>产生电费(元):<span class="content-total-inform">{{listData1.elecFee}}</span></div></br>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>实收电费(元):<span class="content-total-inform">{{listData1.actElecFee}}</span></div>
                                             
                                         </el-aside>
                                         <el-aside width="500px">
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>充电应收费用(元):<span class="content-total-inform">{{listData1.actFee}}</span></div></br>
                                              <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>充电实收电费(元):<span class="content-total-inform">{{listData1.userDeductionFee}}</span></div>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>服务费(元):<span class="content-total-inform">{{listData1.servFee}}</span></div></br>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>结算方式:<span class="content-total-inform">{{listData1.settleMode}}</span></div></br>
                                             <div class="content-total-bottom"><i class="fa fa-flash fa-fw" style="color:#69aa46"></i>本月结算金额(元):<span class="content-total-inform">{{listData1.settleMoney}}</span></div>
                                         </el-aside>
                                    </el-container>
                                </el-container>
                    </div>
                     </div>
        </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    // 系统配置文件
import config from "@/config/config.js";
import pageConfig from './page-config';
import dateUtils from '@/utils/dateUtils';
import axios from 'axios';
    export default {
        components: {
        },
        data() {
            return {
            detailForm:{},
            pageConfig,
            stationName:'',
            proStartDate: "",
            proEndDate: "",
            startDate: "",
            endDate: "",
            checkList: ['01','02','03','04'],
            dateValue: "",
            yearValue: "",
            monthValue: "",
            // proEndDate: '',
            isShow: false,
            searchVal: "",
            selections: [],
            // corps:[],
            custPhone: "",
            dealNo: "",
            stationNo:"",
            ordId: "",
            pageParams: {
                total: 0,
                currentPage: 1,
                pageSize: config.page.pageSize,
                pageLayout: config.page.layout
            },
            queryParam: {
                pageNum: 0,
                pageSize: config.page.pageSize
            },
            listDataAll:[],
            listData: [],
            listData1: [],
            listData2: [],
            listData3: [],
            listData4: [],
            listData5: [],
            listData6: [],
            listData7: "",
            showFix: false,
            initModal: true,
            showPopover: false
            }
        },
        methods: {
            // 选择起始时间
        SearchYear(e) {
            this.proStartDate = e;
        },
        SearchMonth(e) {
            this.proEndDate = e;
        },
        // //选择结束时间
        // updateProEndDate(e) {
        //     this.proEndDate = e;
        // },
        // initCorps(){
        //     this.corps = util.initCorpList(this);
        // },
        // 设置第一个选项
        setCorpNoQueryList() {
            this.corpNo = this.$store.state.corpNo;
            // this.changeCorp();
        },
        init() {
            this.startDate = "";
            this.endDate = "";
            this.searchVal = "";
            this.corpNo = "";
            this.dealNo = this.detailForm.dealNo;//"DEAL1577683869739"
            this.stationNo = this.detailForm.stationNo;//"PT1557674449287"
            this.stationName = this.detailForm.stationName;
            let date = new Date;
            let today = dateUtils.format(date,'y-M');
            this.proEndDate = today;
           if (this.proEndDate == "") {
                this.listData = [];
            } else {
                this.initList();
            }
            // 初始化，面包屑
            },
        getFormInfo(){
            let _ = this;
            _.$S.getFormInfo(_,_.$A.pilestation.pilestation+'/'+_.$store.state.editId,function(res){
                    _.detailForm = res.data.data;
                    _.init();
            });
        },
        handlePageChange(val) {
            this.pageParams.currentPage = val;
            this.initList();
        },
        handleDownload(command) {
            if (command === "a") {
                var _this = this;
                this.showFix = true;
                _this.initQureyParam();
                // _this.queryParam.source = _this.checkList.join(",");
                var downloadParam = {
                tmnlCode: _this.queryParam.tmnlCode
                };
                 _this.queryParam.corpNo = this.$store.state.corpNo;
                 _this.$U.showLoading(_this);
                this.$H.pdfPost( _this, _this.$A.pilestation.bill,JSON.stringify(_this.queryParam),
                function(response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    let fname = _this.yearValue+'年'+_this.monthValue+'月'+'结算记录.pdf';
                    link.href = url;
                    link.setAttribute('download', fname);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);//下载完成移除元素
                    _this.showFix = false;
                    _this.$U.hideLoading(_this);
                },
                config.ajax.exportTimeout
                );
            }
        },
  
        handleCommand(command) {
            if (command === "a") {
                var _this = this;
                this.showFix = true;
                // _this.initQureyParam();
                
                _this.queryParam.source = _this.checkList.join(",");
    
                        var downloadParam = {
                            tmnlCode: _this.queryParam.tmnlCode
                        };
                         _this.queryParam.corpNo = this.$store.state.corpNo;
                        this.$H.post(_this,_this.$A.pilestation.export,JSON.stringify(_this.queryParam)).
                        then(response => {
                            _this.$U.saveExcelFile(response.data.data);
                            _this.showFix = false;
                            config.ajax.exportTimeout
                        });
                    this.showFix = false;
            }
        },
        initList(type) {
        // 列表查询渲染
            var _this = this;
            _this.listDataAll = [];
            _this.listData = [];
            _this.listData1 = [];
            _this.listData2 = [];
            _this.listData3 = [];
            _this.listData4 = [];
            _this.listData5 = [];
            _this.listData6 = [];
            if (this.$U.notNull(type)) {
                if (this.proEndDate == "") {
                this.$U.error("请选择时间");
                return;
                }
            }
            this.showFix = true;
            this.isShow = true;
            _this.initQureyParam(type);
             _this.queryParam.corpNo = this.$store.state.corpNo;
            // var listUrl = config.baseUrl + _this.$A.dealer.record;
            var listUrl =_this.$A.pilestation.record;
            _this.$H.post(_this, listUrl, JSON.stringify(_this.queryParam)).
             then( response => {
                _this.listDataAll = response.data.data.pileOrderEntityList;
                _this.listData = _this.listDataAll;
                _this.pageParams.total = response.data.data.totalNum;
                _this.listData1 = response.data.data;
                _this.listData2 = response.data.data.cardAndPlatRecord;
                _this.listData3 = response.data.data.appOuterRecord;
                _this.listData4 = response.data.data.appInnerRecord;
                _this.listData5 = response.data.data.dealer;
                // _this.listData6 = response.data.messageList.dealer;
                _this.listData6 = response.data.data.station;
                _this.listData7 = _this.listData1.chargeTime[0] +"时" + _this.listData1.chargeTime[1] +"分" +_this.listData1.chargeTime[0] +"秒";
            });
            _this.showFix = false;
        },
        initQureyParam(type) {
            // 初始化查询参数
            // this.queryParam.sortEntityList = [];
            // this.queryParam.sortEntityList.push(util.sortList('registerTime', config.list.sortValue));
            // 初始化查询参数
            // this.queryParam.sortEntityList = [];
            // this.queryParam.sortEntityList.push(util.sortList('registerTime', config.list.sortValue));
            let date = dateUtils.format(this.proEndDate,'y-M');
            
            this.yearValue = date.split("-")[0]
            this.monthValue = date.split("-")[1];
            this.queryParam.dealNo = this.dealNo;
            this.queryParam.stationNo = this.stationNo;
            this.queryParam.pageNum = this.pageParams.currentPage - 1;
            this.queryParam.pageSize = this.pageParams.pageSize;
            this.queryParam.year = this.yearValue;
            this.queryParam.month = this.monthValue;
            this.queryParam.source = this.checkList.join(",");
            if (this.$U.notNull(type) && "search" === type) {
                this.pageParams.currentPage = 1;
            }
        },
        handleSizeChange(val) {
            // 条数变更回调
            this.pageParams.pageSize = val;
            this.pageParams.currentPage = 1;
            this.initList();
        },
        handleSelection(selection) {
            this.selections = selection;
        },
        },
        mounted() {
            this.getFormInfo();
            const that = this;
            window.addEventListener("resize", function() {
            if (!that.initModal) {
                var tempHeight = document.body.clientHeight - 60;
                that.moHeight = {
                height: tempHeight + "px"
                };
            }
            });
        }
    }
</script>